// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3QxD0","footer":"ModalInfo_footer__Scrwm"};